import { Modal, ModalProps } from '@/components/molecule/Modal';
import { WalletOptions } from '@/components/wallet/WalletOptions';
import { appModalManager } from '@/state/app';
import { FC } from 'react';
import { useSetRecoilState } from 'recoil';
import { useTranslation } from '@/hooks/support/translate';

type WalletModalProps = Pick<ModalProps, 'isVisible' | 'isClosable' | 'onClose'>;
const WalletModal: FC<WalletModalProps> = ({ isVisible, isClosable, onClose }) => {
    const setModal = useSetRecoilState(appModalManager);
    const { t } = useTranslation();
    const handleWalletConnected = () => {
        setModal(null);
    };
    return (
        <Modal
            title={t('modal.wallet.title')}
            isVisible={isVisible}
            isClosable={isClosable}
            isArrowOutside={false}
            onClose={onClose}
            titleAlign="left"
            bodyPadding="p-4 pt-0 md:p-6 md:pt-0"
            titlePadding="p-4 pb-0 md:p-6 md:pb-0"
            body={<WalletOptions onConnected={handleWalletConnected} />}
        />
    );
};

export default WalletModal;
